export const TRACK_SHOPPING = {
	ADD_TO_CART: 1,
	CHECKOUT: 2,
	REMOVE_FROM_CART: 3,
	DECREASE_FROM_CART: 4,
};
